var map = {
	"./admin_settings.png": 1806,
	"./appraisals.png": 1807,
	"./catalog.png": 1808,
	"./catalogWhite.png": 1809,
	"./catalog_orders.png": 1810,
	"./cms.png": 1811,
	"./component-fields/Asset.png": 1812,
	"./component-fields/Blocks.png": 1813,
	"./component-fields/Boolean.png": 1814,
	"./component-fields/Date-time.png": 1815,
	"./component-fields/LInk.png": 1816,
	"./component-fields/Markdown.png": 1817,
	"./component-fields/Multi asset.png": 1818,
	"./component-fields/Multi options.png": 1819,
	"./component-fields/Number.png": 1820,
	"./component-fields/Richtext.png": 1821,
	"./component-fields/Single options.png": 1822,
	"./component-fields/Table.png": 1823,
	"./component-fields/Text area.png": 1824,
	"./component-fields/Text.png": 1825,
	"./components.png": 1826,
	"./configuration.png": 1827,
	"./contents.png": 1828,
	"./crm.png": 1829,
	"./custom_order.png": 1830,
	"./customer_credits.png": 1831,
	"./customer_list.png": 1832,
	"./dashboard.png": 1833,
	"./finance.png": 1834,
	"./home.png": 1835,
	"./integrations.png": 1836,
	"./inventory-transfers.png": 1837,
	"./invoice-list.png": 1838,
	"./layaway.png": 1839,
	"./move.png": 1840,
	"./new_sale.png": 1841,
	"./orders.png": 1842,
	"./outgoing-consignments.png": 1843,
	"./payment-methods/amex.png": 1196,
	"./payment-methods/discover.png": 1195,
	"./payment-methods/mastercard.png": 1194,
	"./payment-methods/visa.png": 1193,
	"./payments.png": 1844,
	"./plus.png": 1327,
	"./register.png": 1845,
	"./repair_center.png": 1846,
	"./reports.png": 1847,
	"./services.png": 1848,
	"./trade_in_center.png": 1849
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1672;